import { Injectable } from '@angular/core';
import { MasterdataEndpoint } from '@app/core/endpoints/masterdata-endpoint.service';
import { Observable } from 'rxjs';
import { ApiResponse } from '@app/shared/models/Common/apiresponse.model';

@Injectable({
  providedIn: 'root'
})
export class MasterdataService {

  constructor(private masterdataEndpoint: MasterdataEndpoint) { }

  getTenants(): Observable<any> {
    return this.masterdataEndpoint.getTenantsEndpoint<any>();
  }
  getHealthTenants(): Observable<any> {
    return this.masterdataEndpoint.getHealthTenantsEndpoint<any>();
  }
  getLifeTenants(): Observable<any> {
    return this.masterdataEndpoint.getLifeTenantsEndpoint<any>();
  }
  getLoginProviders(): Observable<any> {
    return this.masterdataEndpoint.getLoginProvidersEndpoint<any>();
  }
  getAllRoles(): Observable<any> {
    return this.masterdataEndpoint.getAllRolesEndPoint<any>();
  }
  getPermissionsLookup(serviceId: number, productId: number): Observable<any> {
    return this.masterdataEndpoint.getPermissionsLookup<any>(serviceId, productId);
  }
  gettenantsbyservice(serviceId: number): Observable<any> {
    return this.masterdataEndpoint.gettenantsbyservice<any>(serviceId);
  }

  getNextApproversByUserType(serviceId: number): Observable<any> {
    return this.masterdataEndpoint.getNextApproversByUserType<any>(serviceId);
  }

  getBusinessEntitiesByTenant(tenantId: number): Observable<any> {
    return this.masterdataEndpoint.getBusinessEntitiesByTenantEndpoint<any>(tenantId);
  }
  getHealthBusinessEntitiesByTenantUserType(tenantId: number, userTypeId: number): Observable<any> {
    return this.masterdataEndpoint.getHealthBusinessEntitiesByTenantUserType<any>(tenantId, userTypeId);
  }
  getLifeBusinessEntitiesByTenantUserType(tenantId: number, userTypeId: number): Observable<any> {
    return this.masterdataEndpoint.getLifeBusinessEntitiesByTenantUserType<any>(tenantId, userTypeId);
  }

  getUserAuthority(userId: string): Observable<any> {
    return this.masterdataEndpoint.getUserAuthorityEndPoint(userId);
  }
  getUserTenants(): Observable<any> {
    return this.masterdataEndpoint.getUSerTenantsEndpoint<any>();
  }
  updateUserAuthority(userAuthority: any) {
    return this.masterdataEndpoint.UpdateUserAuthorityEndpoint<ApiResponse>(userAuthority);
  }

  getCopyFromUsers(userId: string): Observable<any> {
    return this.masterdataEndpoint.getCopyFromUsersEndPoint(userId);
  }

  copyUserAuthority(fromUserId: string, toUserId: string): Observable<boolean> {
    return this.masterdataEndpoint.copyUserAuthorityEndPoint(fromUserId, toUserId);
  }

  regenerateQuotationDoc(quotationId) {
    return this.masterdataEndpoint.UpdateUserAuthorityEndpoint<ApiResponse>(quotationId);
  }
  getTOBSuperScripts() {
    return this.masterdataEndpoint.getTOBSuperScripts<ApiResponse>();
  }
  getMemberRelations(): Observable<any> {
    return this.masterdataEndpoint.getMemberRelations();
  }
  getMaritalStatus(): Observable<any> {
    return this.masterdataEndpoint.getMaritalStatus();
  }
  getCountry(): Observable<any> {
    return this.masterdataEndpoint.getCountry();
  }
  getSurveyQuestions(quotationId, surveyName): Observable<any> {
    return this.masterdataEndpoint.getSurveyQuestions(quotationId, surveyName);
  }
  getUpdateSurveyChildQuestions(mafSurveyAnswersRequest: any): Observable<any> {
    return this.masterdataEndpoint.getUpdateSurveyChildQuestions(mafSurveyAnswersRequest);
  }

  getUWDecisionStatus(): Observable<any> {
    return this.masterdataEndpoint.getUWDecisionStatus<any>();
  }
  getUWAction(): Observable<any> {
    return this.masterdataEndpoint.getUWAction<any>();
  }
}
